/**
 * useMenu hook.
 */
import Focus from '@shared/types/enums/focus';
import useKeyboard from './useKeyboard';
import { setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { userSelector } from '@shared/store/slices/user.slice';
import { useRef } from 'react';

export default function useMenu(
  focus: Focus | number | null,
  handleLeft = false
) {
  const dispatch = useAppDispatch();
  const { isAnonymous } = useAppSelector(userSelector);
  const anonymousRef = useRef(isAnonymous);
  anonymousRef.current = isAnonymous;

  if (handleLeft) {
    useKeyboard({
      canBeFocused: false,
      keyDownHandler: (key) => {
        if (key === 'LEFT') {
          dispatch(pushFocus(Focus.MENU));
        }
      },
    });
  }

  return (key?: string | number) => {
    switch (key) {
      case 'BACK':
      case 'LEFT':
        ![Focus.LOGIN, Focus.MENU].includes(focus as number) &&
          dispatch(setFocus(Focus.MENU));
        break;
    }
  };
}
